module.exports = __webpack_public_path__ + "img/footerBg.a370c451.png";